module.exports = __webpack_public_path__ + "static/media/feel-hero-image.4af1fcc2.jpg";